function removeContextFromRight(rightWithContext: string): string {
    if (rightWithContext.includes(':')) return rightWithContext.split(':')[0]; // return right without context

    return rightWithContext;
}

function normalizeRight(right: string): string {
    return right.toLowerCase();
}

/**
 * Checks if the user has one of the specified rights
 * @param rights Array of rights the user has
 * @param rightWithContext Right to check for
 * @returns True if the user has the specified right with possible context, false otherwise
 */
export function hasRightWithContext(
    rights: string[] | null | undefined,
    rightWithContext: string,
): boolean {
    if (!Array.isArray(rights)) return false;

    const normalizedRights = rights.map(normalizeRight);
    const normalizedRightWithContext = normalizeRight(rightWithContext);

    if (normalizedRights.find((r) => r === '*')) return true; // user has admin rights
    if (normalizedRights.find((r) => r === normalizedRightWithContext)) return true; // user has this specific right with context

    // user has base right, requested right is context-specific
    if (
        normalizedRightWithContext.includes(':') &&
        normalizedRights.find((r) => r === removeContextFromRight(normalizedRightWithContext))
    )
        return true;

    // user has one of the rights without context
    if (
        !normalizedRightWithContext.includes(':') &&
        normalizedRights.find((r) => removeContextFromRight(r) === normalizedRightWithContext)
    )
        return true;

    // TODO: startsWith is not the best approach, because it can lead to false positives
    // user has any right for specified part
    // For example, checking "roles_and_rights" should match "roles_and_rights.manage_roles:123"
    if (
        !normalizedRightWithContext.includes(':') &&
        normalizedRights.find((r) => r.startsWith(`${normalizedRightWithContext}.`))
    )
        return true;

    return false;
}

/**
 * Checks if the user has one of the specified rights
 * @param rights Array of rights the user has
 * @param args Rights to check for
 * @returns True if the user has any of the specified rights, false otherwise
 */
export function hasRight(rights: string[] | null | undefined, ...args: string[]): boolean {
    if (!Array.isArray(rights)) return false;

    for (let i = 0; i < args.length; i++) {
        if (hasRightWithContext(rights, args[i])) return true;
    }

    return false;
}
